var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let BonusSettingsModel = class BonusSettingsModel {
    constructor() {
        this.payment_types = [];
        this.rate = 0;
        this.should_calculate_holiday_bonus = false;
        this.show_forecasted_bonus = false;
    }
};
__decorate([
    JsonProperty("payment_types", [], true)
], BonusSettingsModel.prototype, "payment_types", void 0);
__decorate([
    JsonProperty("rate", Number, true)
], BonusSettingsModel.prototype, "rate", void 0);
__decorate([
    JsonProperty("should_calculate_holiday_bonus", Boolean, true)
], BonusSettingsModel.prototype, "should_calculate_holiday_bonus", void 0);
__decorate([
    JsonProperty("show_forecasted_bonus", Boolean, true)
], BonusSettingsModel.prototype, "show_forecasted_bonus", void 0);
BonusSettingsModel = __decorate([
    JsonObject("BonusSettingsModel")
], BonusSettingsModel);
export { BonusSettingsModel };
//# sourceMappingURL=bonus-settings.model.js.map